module.exports = __webpack_public_path__ + "img/apply_access.fa91914c.png";